import useScreenWidth from 'common/hooks/DOM/useScreenWidth';
import _ from 'lodash';
import { useEffect, useState } from 'react';

const useRightScreenOverflow = ({ anchorEl, threshold = 35 }) => {
  const screenWidth = useScreenWidth();
  const [overflow, setOverflow] = useState(0);
  const openedMenusLength = _.size(anchorEl);

  const onChangeMenus = () => {
    const lastRef = _.last(Object.values(anchorEl));
    if (!lastRef) return;

    const { width, x } = lastRef.getBoundingClientRect();
    const totalWidth = width * 2 * openedMenusLength;
    const xAndWidth = x + totalWidth;
    const diffOverflow = screenWidth - xAndWidth;
    setOverflow(
      diffOverflow < 0
        ? Math.abs(diffOverflow) + threshold * openedMenusLength
        : 0
    );
  };

  useEffect(() => {
    if (openedMenusLength.length === 0) return;
    onChangeMenus();
  }, [openedMenusLength, screenWidth]);

  return overflow;
};

export default useRightScreenOverflow;
